import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import Home from './pages/Home';
import SentryErrorBoundary from './components/SentryErrorBoundary';
import ServerUnavailable from './components/ServerUnavailable';
import GlobalStyles from './styles/GlobalStyles';
import { MainContainer } from './styles/LayoutStyles';
import { useServerHealth } from './hooks/useServerHealth';
const AppContent = () => {
  const { isServerAvailable, isServerDegraded } = useServerHealth();

  if (!isServerAvailable) return <ServerUnavailable />;

  return (
    <>
      {isServerDegraded && (
        <Alert variant='warning' className='m-3 mb-0'>
          We are having intermittent connection issues. You can continue, but some actions may need a retry.
        </Alert>
      )}
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

const App = () => {

  return (
    <>
      <GlobalStyles />
      <MainContainer>
        <SentryErrorBoundary>
          <AppContent />
        </SentryErrorBoundary>
      </MainContainer>
    </>
  );
}

export default App;

